module.exports = __webpack_public_path__ + "img/cns_email_ios17.a9e8c9fe.png";